import React, { useMemo } from 'react';
import { useInstanceNaming } from './InstanceNaming';
import { Anchor, Box, Button, createStyles, Divider, Flex, Paper, Table, Text } from '@mantine/core';
import { GetIsDevMode } from './IsDevMode';
import mailto from 'mailto-link';
import { useAppSelector } from '@/hooks';

const useStyle = createStyles(() => ({
  contactTable: {
    '& tbody td': {
      borderTop: 'none !important',
    },
  },
}));

const Contactcard = () => {
  const contactMail = useInstanceNaming('contactEmail') || (GetIsDevMode() ? 'test@test.de' : '');
  const contactPhone = useInstanceNaming('contactPhone') || (GetIsDevMode() ? '0179551112233' : '');
  const contactName = useInstanceNaming('contactName') || (GetIsDevMode() ? 'Testadmin Testotesto' : '');

  const { classes } = useStyle();

  const visitorId = useAppSelector((state) => state.visitorId.id);

  const contactMailLink = useMemo(() => {
    return mailto({
      to: contactMail,
      subject: `Angebots-ID: ${visitorId} / Problem bei Berechnung`,
    });
  }, [visitorId, contactMail]);

  return (
    <Flex justify={'center'}>
      <Paper
        shadow='sm'
        radius='md'
        withBorder
        maw={400}
        mt={20}
        mb={30}>
        <Box p={'sm'}>
          <Text>
            Leider scheinen wir kein Angebot berechnen zu können. <br />
            <br />
            Bitte überprüfe deine Filtereinstellungen. Sollte das Problem immer noch bestehen, senden Sie uns gerne eine
            E-Mail und wir prüfen Ihr Angebot auf Versicherbarkeit
          </Text>
          <Flex
            justify={'left'}
            mt='lg'>
            <Anchor href={contactMailLink}>
              <Button>Hilfe bekommen</Button>
            </Anchor>
          </Flex>
        </Box>
        <Divider />

        <Table className={classes.contactTable}>
          <tbody>
            <tr>
              <td>Kontakt</td>
              <td>{contactName}</td>
            </tr>
            <tr>
              <td>Email</td>
              <td>
                <Anchor href={'mailto:' + contactMailLink}>{contactMail}</Anchor>
              </td>
            </tr>
            <tr>
              <td>Telefon</td>
              <td>
                <Anchor href={'tel:' + contactPhone}>{contactPhone}</Anchor>
              </td>
            </tr>
          </tbody>
        </Table>
      </Paper>
    </Flex>
  );
};

export default Contactcard;
